import { render } from "./boxFileTree.vue?vue&type=template&id=9ea3d4fa&scoped=true"
import script from "./boxFileTree.vue?vue&type=script&lang=js"
export * from "./boxFileTree.vue?vue&type=script&lang=js"

import "./boxFileTree.vue?vue&type=style&index=0&id=9ea3d4fa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ea3d4fa"]])

export default __exports__